import Toastify from "toastify-js";

up.compiler("[data-clipboard]", (el) => {
  var clipboard = new ClipboardJS(el, {
    text: (trigger) => (
      trigger.getAttribute('data-clipboard')
    )
  });

  clipboard.on('success', function(e) {
    const name = e.trigger.dataset.measurementCopy
    if (name) window.MyMallsMeasurement?.emit(name, { placement: 'suite' })
    Toastify({
      text: "Copied!",
      duration: 1000,
      gravity: "top",
      positionLeft: false,
      backgroundColor: `var(--secondary-500)`,
      stopOnFocus: false
    }).showToast();
    e.clearSelection();
  });

  clipboard.on('error', function(e) {
    if (e.trigger.dataset.measurementCopy === 'shopping_address_copied') window.MyMallsMeasurement?.emit('address_copy_failed', { placement: 'suite', error_category: 'unknown' })
    Toastify({
      text: "Failed to copy!",
      duration: 1000,
      gravity: "top",
      positionLeft: false,
      backgroundColor: `var(--red-500)`,
      stopOnFocus: false
    }).showToast();
  });
})
